import React, {useEffect, useRef, useState} from "react";
import picture from "../../image/picture/picture.png"
import {Button, Divider, Tooltip, Upload} from "antd";
import Message from "../../../common/message";
import {ZKY_URL_DISTRI_GOODS_UPLOAD} from "../../../public/variables";
import Util from "../../../public/utils";
import ZkModal from "../../../common/modal/zkModal";
import zkLogo from "../../../../iconfont/logo/zkLogo";

let imUploadFileResolve;
let imUploadFileReject;
const ImPicture = (props) => {
    const {chatData} = props
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    const okModalRef = useRef()
    const pasterModalRef = useRef()
    const uploadProps = {
        accept: '.jpeg,.gif,.png,.jpg',
        name: 'uploadfile',
        action: ZKY_URL_DISTRI_GOODS_UPLOAD,
        headers: {},
        beforeUpload(file, fileList) {
            setData(file)
            okModalRef.current.show()
            return new Promise((resolve, reject) => {
                //确定 = resolve,执行上传  取消 = reject,不上传
                imUploadFileResolve = resolve;
                imUploadFileReject = reject;
            })
        },
        onChange(info) {
            if (info.file.status == 'uploading') {
                // console.log('9898',info.file, info.fileList);
                setLoading(true)
            }
            if (info.file.status === 'done') {
                setLoading(false)
                okModalRef.current.hide()
                //可能存在上传成功  但是接口返回-1， 捕获异常处理
                try {
                    props.getImg(info.file.response.respMsg)
                } catch (e) {
                    Message.error(`${info.file.name} 上传失败`);
                }
            } else if (info.file.status === 'error') {
                setLoading(false)
                // Message.error(`${info.file.name} 上传失败`);
            }
        },
    };


    function getObjectURL(file) {
        let url = null
        if (window.createObjectURL != undefined) {
            url = window.createObjectURL(file)
        } else if (window.URL != undefined) {
            url = window.URL.createObjectURL(file)
        } else if (window.webkitURL != undefined) {
            url = window.webkitURL.createObjectURL(file)
        }
        return url
    }

    return (
        <>
            <Tooltip placement="top" title={'图片'}>
                <Upload {...uploadProps} className={'im-picture-upload'}>
                    <img src={picture} className={'im-picture'}/>
                </Upload>
            </Tooltip>

            {/*{确认发送modal}*/}
            <ZkModal title={'发送给：'} ref={okModalRef} width={480}
                     footer={[
                         <Button onClick={() => {
                             imUploadFileReject(), okModalRef.current.hide()
                         }}>取消
                         </Button>,
                         <Button loading={loading} type="primary" onClick={() => imUploadFileResolve(data)}>
                             确定
                         </Button>,
                     ]}
                     maskClosable={false} className={'modal-right-btn im-setting-modal'}
                     afterClose={null}
                     destroyOnClose
            >
                {/*{sender info}*/}
                <div className={'im-file-sender'}>
                    {
                        chatData.isRoom == 1 ?
                            <>
                                <img src={chatData.avatar}/>
                                <span>{chatData.name}</span>
                            </>
                            :
                            <>
                                <img src={chatData.avatar}/>
                                <span>{chatData.name}</span>
                                <span className={chatData.corpShortName == '微信' ? 'title-wxName' : 'title-corpName'}>
                                        {chatData.corpShortName ? `@${chatData.corpShortName}` : ''}
                                    </span>
                            </>
                    }
                </div>
                <Divider className={'im-file-divider'}/>
                {/*{发送内容}*/}
                {
                    JSON.stringify(data) != '{}' ?
                        <div className={'im-file-content'}>
                            <img src={getObjectURL(data)}/>
                            <div className={'im-file-right'}>
                                <span>{data.name}</span>
                                <span>{Util.fileSizeToString(data.size)}</span>
                            </div>
                        </div> : ''
                }
            </ZkModal>
        </>
    )
}

export default ImPicture